/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tenants } from '../../models/tenants';

export interface GetAllTenants$Params {

/**
 * Size of the results page.
 */
  size?: number;
  start?: string;

/**
 * query to allow the selection of response payload attributes, allowing whoever calls this endpoint to retrieve only the attributes they need in each context.
 * Examples: `field=name&field=countryCode&field=alias`
 */
  field?: Array<string>;
}

export function getAllTenants(http: HttpClient, rootUrl: string, params?: GetAllTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<Tenants>> {
  const rb = new RequestBuilder(rootUrl, getAllTenants.PATH, 'get');
  if (params) {
    rb.query('size', params.size, {});
    rb.query('start', params.start, {});
    rb.query('field', params.field, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tenants>;
    })
  );
}

getAllTenants.PATH = '/tenants';
